var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "content-centered medium text-left"
  }, [_vm.isAdminNotConsultant ? _c("EventDetails", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      id: _vm.id
    }
  }) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };